import React, { useState, useContext } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { FirebaseContext } from "../../firebase";
import useToast from "../hooks/useToast";
import FileUploader from "react-firebase-file-uploader";

const AgregarCategoria = ({ onCategoriaAgregada }) => {
  const { firebase } = useContext(FirebaseContext);
  const { showSuccess, showError } = useToast();

  const [uploading, setUploading] = useState(false);
  const [progress, setProgress] = useState(0);

  const formik = useFormik({
    initialValues: {
      nombre: "",
      imagen: "",
    },
    validationSchema: Yup.object({
      nombre: Yup.string()
        .min(3, "El nombre debe tener al menos 3 caracteres")
        .required("El nombre es obligatorio"),
    }),
    onSubmit: async (valores) => {
      try {
        // Guardar en Firebase
        const docRef = await firebase.db.collection("categorias").add(valores);
        const nuevaCategoria = { id: docRef.id, ...valores };

        showSuccess("✅ Categoría agregada correctamente");

        // Si hay callback, notificar
        if (onCategoriaAgregada) {
          onCategoriaAgregada(nuevaCategoria);
        } else {
          formik.resetForm();
        }
      } catch (error) {
        console.error(error);
        showError("❌ Error al agregar la categoría");
      }
    },
  });

  const handleUploadStart = () => { setUploading(true); setProgress(0); };
  const handleProgress = (progress) => setProgress(progress);
  const handleUploadError = (error) => { setUploading(false); console.error(error); showError("Error al subir la imagen"); };
  const handleUploadSuccess = async (filename) => {
    try {
      setUploading(false);
      setProgress(100);
      const url = await firebase.storage.ref(`categorias/${filename}`).getDownloadURL();
      formik.setFieldValue("imagen", url);
      showSuccess("✅ Imagen subida correctamente");
    } catch (error) {
      console.error(error);
      showError("❌ Error obteniendo URL de la imagen");
    }
  };

  return (
    <div className="max-w-md mx-auto mt-8 p-6 bg-white rounded shadow">
      <h1 className="text-2xl font-bold mb-4">Agregar Categoría</h1>
      <form onSubmit={formik.handleSubmit} className="space-y-4">
        {/* Nombre */}
        <div>
          <label className="block font-bold">Nombre de la categoría</label>
          <input
            type="text"
            name="nombre"
            value={formik.values.nombre}
            onChange={formik.handleChange}
            className="w-full border p-2 rounded"
          />
          {formik.touched.nombre && formik.errors.nombre && (
            <p className="text-red-500">{formik.errors.nombre}</p>
          )}
        </div>

        {/* Imagen */}
        <div>
          <label className="block font-bold">Imagen (opcional)</label>
          <FileUploader
            accept="image/*"
            name="imagen"
            randomizeFilename
            storageRef={firebase.storage.ref("categorias")}
            onUploadStart={handleUploadStart}
            onUploadError={handleUploadError}
            onUploadSuccess={handleUploadSuccess}
            onProgress={handleProgress}
          />
          {uploading && <p>Cargando imagen... {progress}%</p>}
          {formik.values.imagen && (
            <img src={formik.values.imagen} alt="Vista previa" className="h-24 mt-2" />
          )}
        </div>

        <button
          type="submit"
          className="bg-blue-600 text-white px-4 py-2 rounded w-full"
        >
          Guardar Categoría
        </button>
      </form>
    </div>
  );
};

export default AgregarCategoria;

